<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Susipažinimas su taisyklėmis</h3>

    <v-row>
      <v-col cols="12">
        <v-tabs v-model="taisyklesTab">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            class="taisykles-tab"
            v-for="item in taisyklesList"
            :key="item.value"
          >
            <h4>{{ item.label }}</h4>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <admin-taisykles-search
      class="mt-1 mb-1"
      :loading="loading"
      @search="searchTaisykles"
    />

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.pozymis`]="{ item }">
        <el-button
          primary
          x-small
          @click.native="changeTaisykles(item)"
          :disabled="item.pozymis_disabled"
          >Nuimti požymius</el-button
        >
      </template>
      <template #[`item.snau_sutikimas_teikimas`]="{ item }">
        <el-busena :busena="item.snau_sutikimas_teikimas" taip-ne />
      </template>
      <template #[`item.snau_sutikimas_sauga`]="{ item }">
        <el-busena :busena="item.snau_sutikimas_sauga" taip-ne />
      </template>
      <template #[`item.snau_sutikimas_savitarna`]="{ item }">
        <el-busena :busena="item.snau_sutikimas_savitarna" taip-ne />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <div class="mt-4 mb-2" v-if="!loading">
      {{ taisyklesText }}
    </div>

    <modal-confirm
      title="Susipažinimas su taisyklėmis"
      :text="confirmText"
      :item="confirmItem"
      action="Keitimas"
      v-model="showConfirm"
      @confirmKeitimas="saveData"
      @cancelConfirm="cancelData"
    />
  </v-container>
</template>

<script>
import print from '../../mixins/print'
import AdminTaisyklesSearch from './AdminTaisyklesSearch'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'AdminTaisykles',
  components: {
    ModalConfirm,
    AdminTaisyklesSearch,
  },
  mixins: [print],
  data() {
    return {
      taisyklesTab: null,
      taisyklesList: [
        {
          label: 'TURTAS aplikacija',
          value: 1,
        },
        {
          label: 'RC savitarna',
          value: 2,
        },
        {
          label: 'NEP savitarna',
          value: 3,
        },
      ],
      searchData: {},
      showConfirm: false,
      confirmText: null,
      confirmItem: null,
      pageloading: true,
      loading: true,
      formData: [],
      taisyklesData: null,
      search: null,
      itemsPerPageOptions: [10, 50, 100],
      paginationloading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  watch: {
    taisykles(val) {
      if (val && !this.pageloading) {
        this.getData()
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Asmens vardas',
          align: 'start',
          sortable: true,
          value: 'snau_vardas',
        },
        {
          text: 'Asmens pavardė',
          align: 'start',
          sortable: true,
          value: 'snau_pavarde',
        },
        {
          text: 'Įmonės pavadinimas',
          align: 'start',
          sortable: true,
          value: 'snau_organizacija',
          hide: !this.headerSavitarna,
        },
        {
          text: 'Asmens organizacija ir sutartis',
          align: 'start',
          sortable: true,
          value: 'snau_organizacija',
          hide: this.headerSavitarna,
        },
        {
          text: 'Bandymo prisijungti data ir laikas',
          align: 'start',
          sortable: true,
          value: 'snau_prisijungimo_data',
        },
        {
          text:
            'Susipažino su hipotekos ir įkeitimo duomenų teikimo taisyklėmis',
          align: 'start',
          sortable: true,
          value: 'snau_sutikimas_teikimas',
          hide: this.headerSavitarna,
        },
        {
          text: 'Susipažino su saugos nuostatais',
          align: 'start',
          sortable: true,
          value: 'snau_sutikimas_sauga',
          hide: this.headerSavitarna,
        },
        {
          text: 'Susipažino su savitarnos paslaugų naudojimo sutartimi',
          align: 'start',
          sortable: true,
          value: 'snau_sutikimas_savitarna',
          hide: !this.headerSavitarna,
        },
        {
          text: 'Susipažinimo su taisyklėmis data ir laikas',
          align: 'start',
          sortable: true,
          value: 'snau_sutikimas_su_salygomis_data',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          value: 'pozymis',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        item.pozymis_disabled =
          !item.snau_sutikimas_teikimas && !item.snau_sutikimas_sauga
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    taisyklesText() {
      return `Taisyklių keitimo data ${this.taisyklesData}`
    },
    taisykles() {
      if (this.taisyklesTab === null) {
        return null
      }
      return this.taisyklesList[this.taisyklesTab].value
    },
    isTaisykles() {
      return this.taisykles
    },
    taisyklesSavitarna() {
      return this.taisykles === 2
    },
    taisyklesNtrPaslaugos() {
      return this.taisykles === 3
    },
    headerSavitarna() {
      return this.taisyklesSavitarna || this.taisyklesNtrPaslaugos
    },
  },
  created() {
    // this.getData()
  },
  methods: {
    searchTaisykles(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    getData(resetPageNr = false) {
      this.pageloading = true
      this.loading = true
      this.formData = []

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        savitarna: this.taisyklesSavitarna,
        ntrpaslaugos: this.taisyklesNtrPaslaugos,
        search: this.searchData,
      }

      this.$axios
        .post(`admin/naudotojas`, data)
        .then(res => {
          this.formData = res.data.naudotojai
          this.taisyklesData = res.data.taisykliu_data
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    saveData(item) {
      this.loading = true

      let data = {
        snau_id: item.snau_id,
        snau_sutikimas_su_salygomis: false,
      }

      this.$axios
        .post(`admin/naudotojas/${item.snau_id}`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeTaisykles(item) {
      this.confirmText = `Ar norite nuimti susipažinimo su taisyklėmis požymius naudotojui <b>${item.snau_vardas} ${item.snau_pavarde}</b>?`
      this.confirmItem = item
      this.showConfirm = true
    },
    cancelData() {
      this.showConfirm = false
    },
  },
}
</script>
<style lang="scss" scoped>
.taisykles-tab {
  max-width: 400px;
}
</style>
